module.exports = __webpack_public_path__ + "static/img/pete_profile_1080x1077.15e24fe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pete_profile_1080x1077.jpg
// module id = RTbL
// module chunks = 0